import React, { Component, Dispatch } from 'react';

import { Common } from '../../core/common';
import { IAction, IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Modal } from 'reactstrap';
import * as NotificationPageAction from '../../store/actions/notification';
import { withRouter } from 'react-router-dom';
import { IHeaderOptions } from '../../models/components/header-options';
import moment from 'moment';
import Paginate from '../table/paginate';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
const noNotificationImage = `${process.env.PUBLIC_URL}/images/notifications/no_notification.png`;
export class CActivityNotifications extends Component<any> {

    public state = {
        notificationPage: 1,
        viewActivityStatus: false,
        activityRedirectUrl: ''
    }
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public componentDidMount() {
        this.callApi(this.state.notificationPage);

    }

    callApi = (page: number) => {
        this.props.dispatch(NotificationPageAction.GetActivityNotificationsAll(false, 1, 10, page))
    }

    public onPageChange = async (page: number) => {
        this.setState({ notificationPage: page });
        this.callApi(page);
    };

    viewData = () => {

        let data = [];

        if (this.props.notification) {
            if (this.props.notification.length > 0) {

                this.props.notification.map((x: any) => {
                    data.push(
                        <div className=' container-fluid ' style={{ minHeight: "50px", borderBottom: '1px solid rgb(200,200,200)' }}>
                            <div className="row  m-0  py-4 align-items-center" style={{ width: '100%' }}>
                                <div className='col-md-9 col-12 d-flex text-start align-items-center gap-1' style={{ cursor: "pointer", wordBreak: 'break-word',borderLeft: "0px solid", borderLeftColor: _common.ActivityColours[x.activityType].toString().toLowerCase()  }} >
                                <div className='p-1' style={{ fontSize: "12px", fontWeight: "unset" }}>
                                    <img src={_common.GetActivityTypeIcons(_common.ActivityValues[x.activityType].toString().toLowerCase())} className="notes-icon" /></div>
                                    <span style={{fontWeight:'600'}}>{x.message}</span>
                                </div>
                                <div className='col-md-2 col-6 text-center sm-mt-2 d-flex justify-content-center align-items-center font-weight-bold'>{moment(x.cretedDate).format('DD.MM.YYYY HH:mm')}</div>
                                <div className='col-md-1 col-6 text-center sm-mt-2 d-flex justify-content-center align-items-center'>
                                    <button onClick={e => this.props.onClickActivityNavigateUrl(x.notificationId, x.classId, x.activityId, x.courseId, x.termWeekId, x.activityType)} className="btn btn-success ml-2" style={{ fontSize: '14px' }}>{T.t('r_view_activity')}</button>
                                </div>

                            </div >

                        </div >
                    )
                })
            }
            else {
                data.push(<div className='conversation-popup' style={{position:'relative', fontSize: "14px" }}>
                    <div className='white-box m-0 p-1'>

                        <div className="d-flex justify-content-center p-0"> <img
                            src={noNotificationImage}
                            alt="newActivityCount"
                        /></div>
                        <div className="d-flex justify-content-center p-0"><p style={{ margin: '1em' }}>{T.t('r_notification_not_found')}</p></div>
                    </div> </div>)
            }
        }

        return data;
    }

    public render() {

        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '90vw', margin: '0 auto' }}
                isOpen={true}
                fade={true}
                backdrop={'static'}>
                <div className="white-box">
                    <div className="d-flex justify-content-between white-box-header">
                        <div>
                            <h2>
                                {T.t('r_activities')}
                            </h2>
                        </div>
                        <div className="align-self-center">

                            <a onMouseDown={event => this.props.onActivityNotificatinClick(false)} >
                                <i className="material-icons ml-2 align-middle">close</i>
                            </a>
                        </div>
                    </div>

                    {this.viewData()}

                </div>

                {this.props.notification.length > 0 && this.props.totalCount > 10 && (
                    <Paginate
                        filters={{
                            skip: 0,
                            take: 10,
                            page: this.state.notificationPage,
                            total: this.props.totalCount
                        }}
                        onPageChange={this.onPageChange}
                    />
                )}
            </Modal>
        );
    }
}


const mapStateToProps = (state: IAppState, ownProps: IHeaderOptions): IHeaderOptions => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHeaderOptions = {
        ...ownProps, ... {
            notification: state.notification.activityNotificationsAll,
            totalCount: state.notification.activityUnreadNotificationCountAll
        }
    };

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.notification.activityNotificationsAll === prev.notification.activityNotificationsAll &&
        next.notification.activityUnreadNotificationCountAll === prev.notification.activityUnreadNotificationCountAll;
    return ret;
};


const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};



const ActivityNotifications = connect(mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    })(CActivityNotifications);

export default withRouter<any, any>(ActivityNotifications);
